import type { SVGProps } from 'react';

const SvgUserTypeStandard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20.71 3.29a.996.996 0 0 0-1.41 0l-4.29 4.29-1.29-1.29a.996.996 0 1 0-1.41 1.41l2 2c.2.2.45.29.71.29s.51-.1.71-.29l5-5a.996.996 0 0 0 0-1.41zm-7.58 11.34c.44-.61.75-1.32.84-2.1.06-.55-.33-1.05-.88-1.11a.995.995 0 0 0-1.11.88c-.08.66-.41 1.26-.94 1.67a2.5 2.5 0 0 1-4.03-2.26c.08-.66.41-1.26.94-1.67a2.5 2.5 0 0 1 1.84-.52.995.995 0 0 0 1.11-.88.995.995 0 0 0-.88-1.11c-1.19-.14-2.37.19-3.32.93s-1.54 1.81-1.68 3c-.14 1.17.2 2.27.83 3.16a6.46 6.46 0 0 0-2.87 5.37c0 .55.45 1 1 1s1-.45 1-1c0-1.71.96-3.24 2.47-4 .46.23.96.41 1.5.47a4.5 4.5 0 0 0 2.57-.47c1.5.76 2.46 2.28 2.46 4 0 .55.45 1 1 1s1-.45 1-1c0-2.21-1.1-4.19-2.87-5.37z"
    />
  </svg>
);
export default SvgUserTypeStandard;
